export interface ICartGeolocation {
  clerkId: number;
  merchantId: number;
  coords: {
    lat: number;
    lng: number;
    accuracy: number;
  };
  currentPage: string;
  success: boolean;
  actions: IGeolocationAction[];
}

export interface IGeolocationAction {
  [index: string]: boolean;
}

export enum GeolocationActions {
  SHOW_MERCHANT_SHARING_CREDENTIALS_NOTICE = "SHOW_MERCHANT_SHARING_CREDENTIALS_NOTICE",
  BLOCK_SALES_OUTSIDE_STORE = "BLOCK_SALES_OUTSIDE_STORE",
  LOGOUT = "LOGOUT",
}

export interface ICartGeolocationCheckData {
  success: boolean;
  coords?: {
    accuracy: number | null;
    altitude: number | null;
    altitudeAccuracy: number | null;
    heading: number | null;
    lat: number | null;
    lng: number | null;
    speed: number | null;
  };
  error?: {
    code: string;
    message: string;
  };
}
